import { render } from "./order-list.vue?vue&type=template&id=736c044e&scoped=true&ts=true"
import script from "./order-list.vue?vue&type=script&lang=ts"
export * from "./order-list.vue?vue&type=script&lang=ts"

import "./order-list.vue?vue&type=style&index=0&id=736c044e&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736c044e"]])

export default __exports__